import React from 'react';
import { injectIntl } from 'react-intl';
import { FieldTextInput } from '../..';
import InquiryWizardPanel from '../InquiryWizardPanel';
import InquiryWizardSection from '../InquiryWizardSection';
import InquiryBreakdown from '../InquiryBreakdown';
import { required } from '../../../util/validators';
import css from './InquiryWizardStepSummary.module.css';
import InquiryItinerary from '../InquiryItinerary';

const InquiryWizardStepSummary = ({ intl, listing, formValues }) => {
  return (
    <InquiryWizardPanel>
      <InquiryWizardSection className={css.messageContainer}>
        <FieldTextInput
          id="message"
          name="message"
          type="textarea"
          label={intl.formatMessage(
            {
              id: 'InquiryWizard.additionalQuestions',
            },
            { name: listing.author.attributes.profile.displayName }
          )}
          validate={required(
            intl.formatMessage({
              id: 'InquiryWizard.messageRequired',
            })
          )}
        />
      </InquiryWizardSection>

      <InquiryWizardSection className={css.breakdownContainer}>
        <InquiryItinerary listing={listing} formValues={formValues} />
        <InquiryBreakdown listing={listing} formValues={formValues} />
      </InquiryWizardSection>
    </InquiryWizardPanel>
  );
};

InquiryWizardStepSummary.propTypes = {};

export default injectIntl(InquiryWizardStepSummary);
